import React from 'react';
import { Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const TechReqStatusChip = (params) => {
    let color = 'default';
    let label = '지원요청';

    switch (params.row.reqGrade) {
        case '1':
            label = "지원요청"
            color = 'default';
            break;
        case '2':
            label = "지원확인"
            color = 'info';
            break;
        case '3':
            label = "작업계획"
            color = 'warning';
            break;
        case '4':
            label = "완료보고"
            color = 'error';
            break;
        case '5':
            label = "결재중"
            color = 'secondary';
            break;
        case '6':
            label = "결재완료"
            color = 'success';
            break;
        default:
            break;
    }

    return (
        <Chip
            icon={<CircleIcon />}
            label={label}
            variant="outlined"
            color={color}
        />
    );
};

export default TechReqStatusChip;
